import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import { withRouter } from '@bibliocommons/utils-routing';
import FullScreenOverlay from '@bibliocommons/deprecated-base-full-screen-overlay';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { ExpandableList } from '@bibliocommons/deprecated-expandable';
import { bibShape, ugcTagShape, userIdentityShape, routerShape } from '@bibliocommons/bc-prop-types';

import { TAG_TYPES } from '../../../../constants/TagsConstants';
import TagsUGCEditor from '../../../shared/UGC/UGCEditors/TagsUGCEditor';
import AddButton from '../../../shared/UGC/AddButton';
import DisplayHeading from '../../../shared/UGC/DisplayHeading';
import TagDisplay from '../../../shared/UGC/TagDisplay';
import './TagsInfo.scss';

const QUERY_FIELDS = {
  [TAG_TYPES.GENRE]: 'f_TAG_GENRE',
  [TAG_TYPES.PERSONAL]: 'f_TAG_PERSONAL',
  [TAG_TYPES.MOOD]: 'f_TAG_TONE',
  [TAG_TYPES.SUBJECT]: 'f_TAG_ABOUT'
};

function renderExpandButtonLabel(expanded, bib) {
  const title = bib.getIn(['briefInfo', 'title']);

  if (expanded) {
    return (
      <span>
        <ScreenReaderMessage>
          <FormattedMessage id="ada_show_less_tags" values={{ title }} />
        </ScreenReaderMessage>
        <span aria-hidden>
          <FormattedMessage id="button_show_less" />
        </span>
      </span>
    );
  }

  return (
    <span>
      <ScreenReaderMessage>
        <FormattedMessage id="ada_show_more_tags" values={{ title }} />
      </ScreenReaderMessage>
      <span aria-hidden>
        <FormattedMessage id="button_show_more" />
      </span>
    </span>
  );
}

export class ShelfListItemTagsInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  handleTagClick(e, tag) {
    if (e) {
      e.preventDefault();
    }

    const { router } = this.props;
    const tagValue = tag.get('value');
    const tagType = tag.get('type');

    router.push({
      query: {
        [QUERY_FIELDS[tagType]]: tagValue
      }
    });
  }

  renderTagDisplay(tag) {
    const { owner, tagsTransactions, tagsActions } = this.props;
    const tagValue = tag.get('value');
    const tagType = tag.get('type');

    return (
      <TagDisplay
        key={tag.get('id')}
        tag={tag}
        owner={owner}
        url={`?${QUERY_FIELDS[tagType]}=${tagValue}`}
        handleClick={e => this.handleTagClick(e, tag)}
        tagsTransactions={tagsTransactions}
        tagsActions={tagsActions}
      />
    );
  }

  renderEditor() {
    return (
      this.state.showEditor && (
        <TagsUGCEditor
          bib={this.props.bib}
          owner={this.props.owner}
          existingTags={this.props.ownerTagsForBib}
          tagsActions={this.props.tagsActions}
          tagsTransactions={this.props.tagsTransactions}
          handleClose={this.closeEditor}
        />
      )
    );
  }

  render() {
    const { bib, owner, ownerTagsForBib } = this.props;

    if (ownerTagsForBib && ownerTagsForBib.size > 0) {
      const count = ownerTagsForBib.size;

      return (
        <div className="cp-shelf-list-item-tags-info">
          <DisplayHeading>
            <FormattedMessage id="ugc_tags_display_label" values={{ count }} />
          </DisplayHeading>

          <ExpandableList
            collapseCount={5}
            itemClassName="shelf-tag-pill"
            list={ownerTagsForBib}
            getItemKey={tag => tag.get('id')}
            renderItem={this.renderTagDisplay}
            renderExpandButtonLabel={expanded => renderExpandButtonLabel(expanded, bib)}
          />

          <AddButton
            owner={owner}
            handleClick={this.openEditor}
            screenReaderMessage={
              <FormattedMessage id="ada_add_tags" values={{ title: bib.getIn(['briefInfo', 'title']) }} />
            }
          />

          <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
            {this.renderEditor()}
          </FullScreenOverlay>
        </div>
      );
    }

    return null;
  }
}

ShelfListItemTagsInfo.propTypes = {
  bib: bibShape.isRequired,
  owner: userIdentityShape.isRequired,
  ownerTagsForBib: ImmutablePropTypes.listOf(ugcTagShape),
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  router: routerShape.isRequired
};

export default withRouter(ShelfListItemTagsInfo);
